<template>
  <div :class="{ 'app-container': !fixedScene }">
    <el-card v-if="!fixedScene" class="box-card">
      <el-form :inline="true" size="small">
        <el-form-item label="场景">
          <el-select v-model="sceneId" filterable placeholder="请选择场景" style="width:320px" :disabled="saving" @change="onSceneChange">
            <el-option v-for="s in sceneOptions" :key="s.id" :label="s.title" :value="s.id" />
          </el-select>
        </el-form-item>
      </el-form>
    </el-card>

    <template v-if="sceneId">
      <el-card class="box-card mt10" v-loading="loading">
        <div slot="header">
          基础评分项（合计不超过 80 分）
          <span :class="['sum-badge', baseSum > 80 ? 'over' : 'ok']">当前合计：{{ baseSum }} 分</span>
        </div>
        <el-alert v-if="loadError" :title="loadError" type="error" :closable="false" class="mb10">
          <el-button type="text" @click="onSceneChange(sceneId)">重新加载</el-button>
        </el-alert>
        <el-alert v-if="baseSum > 80" title="基础评分项合计超过 80 分，请调整各项满分后保存" type="error" :closable="false" class="mb10" />
        <el-alert title="选择业务类别后，报告将按重点考核、标准流程和表达能力展示详情。旧评分项可保留“其他”，细项不单独分配分数。" type="info" :closable="false" class="mb10" />
        <el-table :data="baseItems" border size="small">
          <el-table-column label="业务类别" width="150">
            <template slot-scope="{row}">
              <el-select v-model="row.categoryCode" size="mini" placeholder="请选择" :disabled="!canEdit || saving || loading || !!loadError">
                <el-option v-for="c in categories" :key="c.value" :label="c.label" :value="c.value" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="评分项名称" min-width="150">
            <template slot-scope="{row}"><el-input v-model="row.name" size="mini" maxlength="60" placeholder="如：需求确认" :disabled="!canEdit || saving || loading || !!loadError" /></template>
          </el-table-column>
          <el-table-column label="细化考核点 / 流程步骤" min-width="170">
            <template slot-scope="{row, $index}">
              <span>{{ row.subItems.length }} 项</span>
              <el-button type="text" size="mini" :disabled="!canEdit || !!loadError || loading || saving" @click="openDetails(row, $index)">配置明细</el-button>
            </template>
          </el-table-column>
          <el-table-column label="满分" width="120">
            <template slot-scope="{row}"><el-input-number v-model="row.maxScore" :min="0" :max="80" size="mini" controls-position="right" style="width:100%" :disabled="!canEdit || saving || loading || !!loadError" /></template>
          </el-table-column>
          <el-table-column label="评分标准" min-width="240">
            <template slot-scope="{row}"><el-input v-model="row.criteria" type="textarea" :autosize="{ minRows: 3, maxRows: 8 }" size="mini" placeholder="说明满分要求、扣分条件和判断依据" :disabled="!canEdit || saving || loading || !!loadError" /></template>
          </el-table-column>
          <el-table-column label="排序" width="110">
            <template slot-scope="{row}"><el-input-number v-model="row.sort" :min="0" size="mini" controls-position="right" style="width:100%" :disabled="!canEdit || saving || loading || !!loadError" /></template>
          </el-table-column>
          <el-table-column label="操作" width="70">
            <template slot-scope="{$index}">
              <el-button type="text" class="danger-text" :disabled="!canEdit || !!loadError || loading || saving" @click="removeBaseItem($index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt10">
          <el-button size="mini" icon="el-icon-plus" :disabled="!canEdit || !!loadError || loading || saving" @click="addBaseItem">新增评分项</el-button>
        </div>
      </el-card>

      <el-card class="box-card mt10">
        <div slot="header">难度评分项（按场景难度自动生成，不可编辑）</div>
        <el-table :data="difficultyItems" border size="small">
          <el-table-column prop="name" label="项名" />
          <el-table-column prop="maxScore" label="满分" width="100" />
          <el-table-column prop="criteria" label="说明" min-width="240" />
        </el-table>
      </el-card>

      <div v-if="showSave" class="mt10 save-bar">
        <el-button type="primary" :loading="saving" :disabled="baseSum > 80 || loading || !!loadError" @click="handleSave" v-hasPermi="['aiTrain:scoreTemplate:edit']">保存评分表</el-button>
      </div>
    </template>
    <el-empty v-else description="请先选择场景" />

    <el-dialog :title="detailCategory === 'process' ? '标准流程步骤' : '细化考核点'" :visible.sync="detailsVisible" width="650px" append-to-body :close-on-click-modal="false">
      <el-alert :title="detailCategory === 'process' ? '按期望执行顺序逐项填写流程步骤，可用上移、下移调整顺序。' : '逐项填写需要核对的内容；满分和扣分条件在评分标准中统一设置。'" type="info" :closable="false" class="mb10" />
      <div v-for="(point, index) in detailPoints" :key="index" class="point-row">
        <span class="point-number">{{ index + 1 }}</span>
        <el-input v-model="detailPoints[index]" size="small" maxlength="300" placeholder="请输入具体考核点或流程步骤" />
        <el-button type="text" :disabled="index === 0" @click="movePoint(index, -1)">上移</el-button>
        <el-button type="text" :disabled="index === detailPoints.length - 1" @click="movePoint(index, 1)">下移</el-button>
        <el-button type="text" class="danger-text" @click="detailPoints.splice(index, 1)">删除</el-button>
      </div>
      <el-button size="small" icon="el-icon-plus" @click="detailPoints.push('')">新增{{ detailCategory === 'process' ? '步骤' : '考核点' }}</el-button>
      <div slot="footer">
        <el-button @click="detailsVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmDetails">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listRows } from '@/utils/ai-train-data'
import aiTrainSceneApi from '@/api/aiTrain/scene'
import aiTrainScoreTemplateApi from '@/api/aiTrain/scoreTemplate'

const CATEGORIES = [
  { value: 'material', label: '物资准备' },
  { value: 'confidence', label: '气场自信 / 表达能力' },
  { value: 'tool', label: '工具使用' },
  { value: 'content', label: '内容 / 重点考核' },
  { value: 'process', label: '流程 / 标准流程' },
  { value: 'other', label: '其他（兼容旧项）' }
]

function normalizeSubItems(value) {
  if (Array.isArray(value)) return value.filter(v => typeof v === 'string')
  if (typeof value !== 'string' || !value.trim()) return []
  try {
    const parsed = JSON.parse(value)
    if (Array.isArray(parsed)) return parsed.filter(v => typeof v === 'string')
  } catch (e) { /* 兼容早期逗号分隔配置 */ }
  return value.split(/[,，]/).map(v => v.trim()).filter(Boolean)
}

export default {
  name: 'AiTrainScoreTemplate',
  props: { fixedScene: { type: Object, default: null }, showSave: { type: Boolean, default: true } },
  data() {
    return {
      categories: CATEGORIES,
      sceneOptions: [],
      sceneId: null,
      loading: false,
      saving: false,
      loadError: '',
      loadSequence: 0,
      baseItems: [],
      difficultyItems: [],
      detailsVisible: false,
      detailIndex: -1,
      detailCategory: 'other',
      detailPoints: [],
      initialItemsKey: ''
    }
  },
  computed: {
    canEdit() {
      const permissions = this.$store && this.$store.getters && this.$store.getters.permissions
      return Array.isArray(permissions) && (permissions.includes('*:*:*') || permissions.includes('aiTrain:scoreTemplate:edit'))
    },
    isDirty() { return !this.loading && !this.loadError && (JSON.stringify(this.baseItems) !== this.initialItemsKey || this.detailsVisible) },
    baseSum() {
      return this.baseItems.reduce((sum, it) => sum + (Number(it.maxScore) || 0), 0)
    }
  },
  created() {
    if (this.fixedScene) {
      const id = Number(this.fixedScene.id)
      if (!Number.isSafeInteger(id) || id <= 0) { this.loadError = '场景不可用，请关闭后重新打开'; return }
      this.sceneId = id
      this.onSceneChange(id)
      return
    }
    this.loadSceneOptions().then(() => {
      const q = this.$route.query
      if (q.sceneId) {
        this.sceneId = Number(q.sceneId)
        this.onSceneChange(this.sceneId)
      }
    })
  },
  watch: { saving(value) { this.$emit('busy-change', value) } },
  beforeDestroy() { ++this.loadSequence },
  methods: {
    loadSceneOptions() {
      return aiTrainSceneApi.fetchList({ pageNo: 1, pageSize: 500 })
        .then(res => { this.sceneOptions = listRows((res && res.data) || res || {}) })
        .catch(() => { this.sceneOptions = [] })
    },
    onSceneChange(id) {
      const sequence = ++this.loadSequence
      this.loading = true
      this.loadError = ''
      this.baseItems = []
      this.difficultyItems = []
      this.detailsVisible = false
      return aiTrainScoreTemplateApi.fetchList(id)
        .then(res => {
          if (sequence !== this.loadSequence) return
          const items = listRows((res && res.data) || res || [])
          this.baseItems = items.filter(i => i.groupType === 1 || !i.groupType).map(i => ({
            ...i,
            categoryCode: CATEGORIES.some(c => c.value === i.categoryCode) ? i.categoryCode : 'other',
            subItems: normalizeSubItems(i.subItems)
          }))
          this.difficultyItems = items.filter(i => i.groupType === 2)
          if (!this.baseItems.length) this.addBaseItem()
          this.initialItemsKey = JSON.stringify(this.baseItems)
          return true
        })
        .catch(() => {
          if (sequence === this.loadSequence) this.loadError = '评分表加载失败，请重新加载后再编辑，避免覆盖原配置。'
          return false
        })
        .finally(() => { if (sequence === this.loadSequence) this.loading = false })
    },
    addBaseItem() {
      this.baseItems.push({ id: null, groupType: 1, categoryCode: 'other', name: '', subItems: [], maxScore: 0, criteria: '', sort: this.baseItems.length })
    },
    removeBaseItem(index) {
      this.baseItems.splice(index, 1)
    },
    openDetails(row, index) {
      this.detailIndex = index
      this.detailCategory = row.categoryCode
      this.detailPoints = row.subItems.slice()
      this.detailsVisible = true
    },
    movePoint(index, direction) {
      const target = index + direction
      if (target < 0 || target >= this.detailPoints.length) return
      const point = this.detailPoints.splice(index, 1)[0]
      this.detailPoints.splice(target, 0, point)
    },
    confirmDetails() {
      if (this.detailPoints.some(p => !p.trim())) {
        this.$message.warning('请填写所有明细，或删除空行')
        return
      }
      const row = this.baseItems[this.detailIndex]
      if (row) row.subItems = this.detailPoints.map(p => p.trim())
      this.detailsVisible = false
    },
    handleSave() {
      if (!this.canEdit) { this.$message.warning('当前账号没有评分表编辑权限'); return Promise.resolve(false) }
      if (this.loading || this.loadError || this.saving) return
      if (this.baseSum > 80) {
        this.$message.error('基础评分项合计超过 80 分，无法保存')
        return
      }
      if (this.baseItems.some(i => !i.name || !i.name.trim())) {
        this.$message.error('存在未填写名称的评分项')
        return
      }
      this.saving = true
      const items = this.baseItems.map(i => ({
        id: i.id,
        groupType: 1,
        categoryCode: i.categoryCode,
        name: i.name.trim(),
        subItems: i.subItems.slice(),
        maxScore: i.maxScore,
        criteria: i.criteria,
        sort: i.sort
      }))
      return aiTrainScoreTemplateApi.save(this.sceneId, items)
        .then(() => {
          this.$message.success('保存成功')
          return this.onSceneChange(this.sceneId)
        })
        .catch(() => false).finally(() => { this.saving = false })
    }
  }
}
</script>

<style scoped>
.mt10 { margin-top: 10px; }
.mb10 { margin-bottom: 10px; }
.sum-badge { float: right; font-weight: bold; }
.sum-badge.ok { color: #67c23a; }
.sum-badge.over { color: #f56c6c; }
.save-bar { text-align: right; }
.danger-text { color: #f56c6c; }
.point-row { display: flex; align-items: center; gap: 12px; margin-bottom: 12px; }
.point-number { width: 20px; flex-shrink: 0; color: #909399; }
.point-row .el-input { flex: 1; }
.point-row .el-button { margin-left: 0; }
</style>
